// extracted by mini-css-extract-plugin
export default {"container":"certificates_tab-module___container___e2c29978"};